import { render, staticRenderFns } from "./Invioce.vue?vue&type=template&id=f3293796&scoped=true&"
import script from "./Invioce.vue?vue&type=script&lang=js&"
export * from "./Invioce.vue?vue&type=script&lang=js&"
import style0 from "./Invioce.vue?vue&type=style&index=0&id=f3293796&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3293796",
  null
  
)

export default component.exports